import React, { FC } from "react";

import { OnboardingAside, OnboardingContent, PlaceLoadingSpinner } from "@xapp/components";

import { OnboardingProps } from "../../models";

export interface TrainingStepProps {
    /**
     * Optional style applied to the root div
     */
    style?: React.CSSProperties;
    /**
     * Optional class name to apply to the root div
     */
    className?: string;
    /**
     * Optional aside content
     */
    aside?: React.ReactNode;
    /**
     * The current onboarding state
     */
    onboarding: OnboardingProps;
}

export const TrainingStep: FC<TrainingStepProps> = (props) => {
    const { aside, onboarding } = props;

    const header = onboarding?.place ? `Analyzing your Google Business Profile` : "Analyzing website...";

    return (
        <>
            {aside && <OnboardingAside>{aside}</OnboardingAside>}

            <OnboardingContent>
                <h3>{header}</h3>
                <PlaceLoadingSpinner place={onboarding?.place} />
            </OnboardingContent>
        </>
    );
};
